<template>
  <q-dialog
    :model-value="visible"
    no-backdrop-dismiss
    no-esc-dismiss
    no-route-dismiss
    maximized
    transition-show="fade"
    transition-hide="fade"
  >
    <div class="system-dialog">
      <q-card class="q-py-xl q-px-md">
        <mira-logo
          width="125px"
          height="32px"
          type="horizontal"
          class="q-mb-xl"
        />

        <q-item-label class="text-h4 sys-title q-pb-md">
          Updating {{ siteName }}
        </q-item-label>

        <q-item-label class="sys-descr text-h6 q-pb-lg">
          <template v-if="ota.status === 'installing'">
            Version {{ ota.version }} has downloaded. The app will now restart.
          </template>
          <template v-else>
            Downloading version {{ ota.version }}
          </template>
        </q-item-label>

        <!-- Capgo reports coarse progress for a single zip (0, 70, 90, 100), so
             stay indeterminate until a real figure arrives -->
        <q-linear-progress
          :value="ota.percent / 100"
          :indeterminate="ota.status === 'installing' || ota.percent === 0"
          color="blue-7"
          track-color="grey-3"
          size="8px"
          rounded
          class="sys-descr"
        />
        <q-item-label v-if="ota.status === 'downloading' && ota.percent > 0" class="q-pt-sm text-grey-7">
          {{ ota.percent }}%
        </q-item-label>
      </q-card>
    </div>
  </q-dialog>
</template>

<script>
import { otaState } from 'src/helpers/otaUpdate'

/**
 * Full-screen takeover while a Capgo bundle downloads and installs.
 * Not dismissable: boot/capacitor.js restarts into the new bundle as soon
 * as the download completes, so every device runs the same version.
 */
export default {
  data () {
    return {
      ota: otaState
    }
  },
  computed: {
    visible () {
      return this.ota.status === 'downloading' || this.ota.status === 'installing'
    }
  }
}
</script>

<style scoped lang="scss">
.system-dialog {
  .q-card {
    max-width: 500px;

    .sys-descr {
      max-width: 400px;
    }
  }
}
</style>
